import { ConfigServiceProvider } from '../config-service/config-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MapOfStringTo } from '../../../ranking/interfaces/utils';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { UserType } from '../users-service/interfaces/user-type.enum';

@Injectable()
export class DisplayServiceProvider {
  // todo: type screens, newBadges and newLevels
  private screens: MapOfStringTo<any> = {};
  private screensType = 'default';
  private readonly screensUrl = '../../../../assets/screens.json';
  // newLevels and newBadges don't seem to be read at any point
  private newLevels = [];
  private newBadges = [];

  constructor(private configService: ConfigServiceProvider, private storageService: StorageServiceProvider, public http: HttpClient) {}

  public load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.getSource())
        .toPromise()
        .then((screens: MapOfStringTo<any>) => {
          this.screens = ENVIRONMENT.useLocalConfigs ? screens[this.screensType] : screens;
          return this.storageService.setObject('screens', this.screens);
        })
        .then(
          () => resolve(),
          (error) => reject(error),
        );
    });
  }

  private getSource(): string {
    if (ENVIRONMENT.useLocalConfigs) return this.screensUrl;
    return this.configService.getEngineUrl('screens');
  }

  // todo: type return value
  // TODO: wywalić screen
  // I don't understand why it is done this way. this.screens[this.screensType]['start'] and this.screens[this.screensType][screen]
  // don't seem to be used anywhere, but there's 20 calls to getScreenComponent with different values of 'screen'
  public getScreenComponent(screen: string, component: string) {
    if (!this.screens['start'] && !this.screens[screen]) {
      return null;
    }
    return this.screens[component];
  }

  public setScreenType(type: string) {
    this.screensType = type;
  }

  // maybe to remove
  public setNewLevels(levels) {
    this.newLevels = levels;
  }

  // maybe to remove
  public setNewBadges(badges) {
    this.newBadges = badges;
  }

  public getCurrentUserScreens(): any {
    return this.screens;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/display-service/display-service.ts